export class RoutePropertyChanged {

    public routeId: number;
    public result: boolean;
    public previousPhaseCreated: boolean;
    public previousPhaseId: number;
    public actualPhaseId: number;
    public phasesTouched: boolean;


    static setRouteId(data: RoutePropertyChanged, routeId: number): RoutePropertyChanged {
        if (data != null)
            data.routeId = routeId;
        return data;
    }
}